<template>
  <div id="app">
    <router-view />
    <Footer v-if="showFooter" />
  </div>
</template>

<script>
import '@/styles/Global.css';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  components: {
    Footer
  },
  computed: {
    showFooter() {
      const hiddenRoutes = ['/', '/login', '/auth'];
      return !hiddenRoutes.includes(this.$route.path);
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */

}
</style>
